document.documentElement.className = document.documentElement.className.replace('no-js', ''); //Remove no-js class ASAP

//For keeping track of product data
window.productJSON = [];
function addProductJSON(json) {
  window.productJSON.push(json);
}

$("#tabs a").click(function(){
  rel = $(this).attr("rel");
  if ($(this).hasClass("current")) {
    return false;
  }
  $("#tabs a").removeClass('current');
  $(this).addClass('current');
  $(".hidden").fadeOut(400);
  $("#"+rel).delay(400).fadeIn(400);
});

//window.selectCallback is standard location for this function. Called whenever variant dropdown changes.
//Shopify's multi-currency code depends on it.
window.selectCallback = function(variant, selector){
  var $form = $(document.getElementById(selector.domIdPrefix)).closest('form');
  var $button = $form.find('input[type="submit"]');
  var $price = $form.closest('.detail').find('.price');
  //Update price & add-to-cart button states
  if(variant && variant.available == true) {
    $button.removeAttr('disabled');
    var priceHTML = Shopify.formatMoney(variant.price);
    if(variant.compare_at_price > variant.price) {
      priceHTML = '<span class="was-price">' + Shopify.formatMoney(variant.compare_at_price) + '</span>' + priceHTML;
    }
    $price.html(priceHTML);
  } else {
    $button.attr('disabled', 'disabled');
    $price.html(variant ? "Out of stock" : "Unavailable");
                }
                /* Variant Image Linking */
                if (variant && variant.featured_image) {
                var newImageUrl = Shopify.Image.getSizedImageUrl('' + variant.featured_image.src, 'master');
                $form.closest('.product-detail').find('.gallery .thumbnails a[data-full-size-url^="' + newImageUrl.split('?')[0] + '"]').first().trigger('select');
                }
                }

                //Lightbox
                var fbOpts = { overlayColor: '#fff', padding: 1, margin: 60, overlayOpacity: 0.9 };

                /*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

                jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

    /* Modernizr 2.6.2 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-csstransitions-input-testprop-testallprops-domprefixes-load
 */
    ;window.Modernizr=function(a,b,c){function w(a){i.cssText=a}function x(a,b){return w(prefixes.join(a+";")+(b||""))}function y(a,b){return typeof a===b}function z(a,b){return!!~(""+a).indexOf(b)}function A(a,b){for(var d in a){var e=a[d];if(!z(e,"-")&&i[e]!==c)return b=="pfx"?e:!0}return!1}function B(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:y(f,"function")?f.bind(d||b):f}return!1}function C(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+m.join(d+" ")+d).split(" ");return y(b,"string")||y(b,"undefined")?A(e,b):(e=(a+" "+n.join(d+" ")+d).split(" "),B(e,b,c))}function D(){e.input=function(c){for(var d=0,e=c.length;d<e;d++)q[c[d]]=c[d]in j;return q.list&&(q.list=!!b.createElement("datalist")&&!!a.HTMLDataListElement),q}("autocomplete autofocus list placeholder max min multiple pattern required step".split(" "))}var d="2.6.2",e={},f=b.documentElement,g="modernizr",h=b.createElement(g),i=h.style,j=b.createElement("input"),k={}.toString,l="Webkit Moz O ms",m=l.split(" "),n=l.toLowerCase().split(" "),o={},p={},q={},r=[],s=r.slice,t,u={}.hasOwnProperty,v;!y(u,"undefined")&&!y(u.call,"undefined")?v=function(a,b){return u.call(a,b)}:v=function(a,b){return b in a&&y(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=s.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(s.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(s.call(arguments)))};return e}),o.csstransitions=function(){return C("transition")};for(var E in o)v(o,E)&&(t=E.toLowerCase(),e[t]=o[E](),r.push((e[t]?"":"no-")+t));return e.input||D(),e.addTest=function(a,b){if(typeof a=="object")for(var d in a)v(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof enableClasses!="undefined"&&enableClasses&&(f.className+=" "+(b?"":"no-")+a),e[a]=b}return e},w(""),h=j=null,e._version=d,e._domPrefixes=n,e._cssomPrefixes=m,e.testProp=function(a){return A([a])},e.testAllProps=C,e}(this,this.document),function(a,b,c){function d(a){return"[object Function]"==o.call(a)}function e(a){return"string"==typeof a}function f(){}function g(a){return!a||"loaded"==a||"complete"==a||"uninitialized"==a}function h(){var a=p.shift();q=1,a?a.t?m(function(){("c"==a.t?B.injectCss:B.injectJs)(a.s,0,a.a,a.x,a.e,1)},0):(a(),h()):q=0}function i(a,c,d,e,f,i,j){function k(b){if(!o&&g(l.readyState)&&(u.r=o=1,!q&&h(),l.onload=l.onreadystatechange=null,b)){"img"!=a&&m(function(){t.removeChild(l)},50);for(var d in y[c])y[c].hasOwnProperty(d)&&y[c][d].onload()}}var j=j||B.errorTimeout,l=b.createElement(a),o=0,r=0,u={t:d,s:c,e:f,a:i,x:j};1===y[c]&&(r=1,y[c]=[]),"object"==a?l.data=c:(l.src=c,l.type=a),l.width=l.height="0",l.onerror=l.onload=l.onreadystatechange=function(){k.call(this,r)},p.splice(e,0,u),"img"!=a&&(r||2===y[c]?(t.insertBefore(l,s?null:n),m(k,j)):y[c].push(l))}function j(a,b,c,d,f){return q=0,b=b||"j",e(a)?i("c"==b?v:u,a,b,this.i++,c,d,f):(p.splice(this.i++,0,a),1==p.length&&h()),this}function k(){var a=B;return a.loader={load:j,i:0},a}var l=b.documentElement,m=a.setTimeout,n=b.getElementsByTagName("script")[0],o={}.toString,p=[],q=0,r="MozAppearance"in l.style,s=r&&!!b.createRange().compareNode,t=s?l:n.parentNode,l=a.opera&&"[object Opera]"==o.call(a.opera),l=!!b.attachEvent&&!l,u=r?"object":l?"script":"img",v=l?"script":u,w=Array.isArray||function(a){return"[object Array]"==o.call(a)},x=[],y={},z={timeout:function(a,b){return b.length&&(a.timeout=b[0]),a}},A,B;B=function(a){function b(a){var a=a.split("!"),b=x.length,c=a.pop(),d=a.length,c={url:c,origUrl:c,prefixes:a},e,f,g;for(f=0;f<d;f++)g=a[f].split("="),(e=z[g.shift()])&&(c=e(c,g));for(f=0;f<b;f++)c=x[f](c);return c}function g(a,e,f,g,h){var i=b(a),j=i.autoCallback;i.url.split(".").pop().split("?").shift(),i.bypass||(e&&(e=d(e)?e:e[a]||e[g]||e[a.split("/").pop().split("?")[0]]),i.instead?i.instead(a,e,f,g,h):(y[i.url]?i.noexec=!0:y[i.url]=1,f.load(i.url,i.forceCSS||!i.forceJS&&"css"==i.url.split(".").pop().split("?").shift()?"c":c,i.noexec,i.attrs,i.timeout),(d(e)||d(j))&&f.load(function(){k(),e&&e(i.origUrl,h,g),j&&j(i.origUrl,h,g),y[i.url]=2})))}function h(a,b){function c(a,c){if(a){if(e(a))c||(j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}),g(a,j,b,0,h);else if(Object(a)===a)for(n in m=function(){var b=0,c;for(c in a)a.hasOwnProperty(c)&&b++;return b}(),a)a.hasOwnProperty(n)&&(!c&&!--m&&(d(j)?j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}:j[n]=function(a){return function(){var b=[].slice.call(arguments);a&&a.apply(this,b),l()}}(k[n])),g(a[n],j,b,n,h))}else!c&&l()}var h=!!a.test,i=a.load||a.both,j=a.callback||f,k=j,l=a.complete||f,m,n;c(h?a.yep:a.nope,!!i),i&&c(i)}var i,j,l=this.yepnope.loader;if(e(a))g(a,0,l,0);else if(w(a))for(i=0;i<a.length;i++)j=a[i],e(j)?g(j,0,l,0):w(j)?B(j):Object(j)===j&&h(j,l);else Object(a)===a&&h(a,l)},B.addPrefix=function(a,b){z[a]=b},B.addFilter=function(a){x.push(a)},B.errorTimeout=1e4,null==b.readyState&&b.addEventListener&&(b.readyState="loading",b.addEventListener("DOMContentLoaded",A=function(){b.removeEventListener("DOMContentLoaded",A,0),b.readyState="complete"},0)),a.yepnope=k(),a.yepnope.executeStack=h,a.yepnope.injectJs=function(a,c,d,e,i,j){var k=b.createElement("script"),l,o,e=e||B.errorTimeout;k.src=a;for(o in d)k.setAttribute(o,d[o]);c=j?h:c||f,k.onreadystatechange=k.onload=function(){!l&&g(k.readyState)&&(l=1,c(),k.onload=k.onreadystatechange=null)},m(function(){l||(l=1,c(1))},e),i?k.onload():n.parentNode.insertBefore(k,n)},a.yepnope.injectCss=function(a,c,d,e,g,i){var e=b.createElement("link"),j,c=i?h:c||f;e.href=a,e.rel="stylesheet",e.type="text/css";for(j in d)e.setAttribute(j,d[j]);g||(n.parentNode.insertBefore(e,n),m(c,0))}}(this,document),Modernizr.load=function(){yepnope.apply(window,[].slice.call(arguments,0))};

    /* Placeholders.js v2.1.1 */
    (function(t){"use strict";function e(t,e,r){return t.addEventListener?t.addEventListener(e,r,!1):t.attachEvent?t.attachEvent("on"+e,r):void 0}function r(t,e){var r,n;for(r=0,n=t.length;n>r;r++)if(t[r]===e)return!0;return!1}function n(t,e){var r;t.createTextRange?(r=t.createTextRange(),r.move("character",e),r.select()):t.selectionStart&&(t.focus(),t.setSelectionRange(e,e))}function a(t,e){try{return t.type=e,!0}catch(r){return!1}}t.Placeholders={Utils:{addEventListener:e,inArray:r,moveCaret:n,changeType:a}}})(this),function(t){"use strict";function e(){}function r(t,e){var r,n,a=!!e&&t.value!==e,u=t.value===t.getAttribute(V);return(a||u)&&"true"===t.getAttribute(D)?(t.setAttribute(D,"false"),t.value=t.value.replace(t.getAttribute(V),""),t.className=t.className.replace(R,""),n=t.getAttribute(z),n&&(t.setAttribute("maxLength",n),t.removeAttribute(z)),r=t.getAttribute(I),r&&(t.type=r),!0):!1}function n(t){var e,r,n=t.getAttribute(V);return""===t.value&&n?(t.setAttribute(D,"true"),t.value=n,t.className+=" "+k,r=t.getAttribute(z),r||(t.setAttribute(z,t.maxLength),t.removeAttribute("maxLength")),e=t.getAttribute(I),e?t.type="text":"password"===t.type&&K.changeType(t,"text")&&t.setAttribute(I,"password"),!0):!1}function a(t,e){var r,n,a,u,i;if(t&&t.getAttribute(V))e(t);else for(r=t?t.getElementsByTagName("input"):p,n=t?t.getElementsByTagName("textarea"):h,i=0,u=r.length+n.length;u>i;i++)a=r.length>i?r[i]:n[i-r.length],e(a)}function u(t){a(t,r)}function i(t){a(t,n)}function l(t){return function(){b&&t.value===t.getAttribute(V)&&"true"===t.getAttribute(D)?K.moveCaret(t,0):r(t)}}function o(t){return function(){n(t)}}function c(t){return function(e){return m=t.value,"true"===t.getAttribute(D)&&m===t.getAttribute(V)&&K.inArray(C,e.keyCode)?(e.preventDefault&&e.preventDefault(),!1):void 0}}function s(t){return function(){r(t,m),""===t.value&&(t.blur(),K.moveCaret(t,0))}}function d(t){return function(){t===document.activeElement&&t.value===t.getAttribute(V)&&"true"===t.getAttribute(D)&&K.moveCaret(t,0)}}function g(t){return function(){u(t)}}function v(t){t.form&&(L=t.form,L.getAttribute(P)||(K.addEventListener(L,"submit",g(L)),L.setAttribute(P,"true"))),K.addEventListener(t,"focus",l(t)),K.addEventListener(t,"blur",o(t)),b&&(K.addEventListener(t,"keydown",c(t)),K.addEventListener(t,"keyup",s(t)),K.addEventListener(t,"click",d(t))),t.setAttribute(U,"true"),t.setAttribute(V,E),n(t)}var p,h,b,f,m,A,y,E,x,L,T,N,S,w=["text","search","url","tel","email","password","number","textarea"],C=[27,33,34,35,36,37,38,39,40,8,46],B="#ccc",k="placeholdersjs",R=RegExp("(?:^|\\s)"+k+"(?!\\S)"),V="data-placeholder-value",D="data-placeholder-active",I="data-placeholder-type",P="data-placeholder-submit",U="data-placeholder-bound",j="data-placeholder-focus",q="data-placeholder-live",z="data-placeholder-maxlength",F=document.createElement("input"),G=document.getElementsByTagName("head")[0],H=document.documentElement,J=t.Placeholders,K=J.Utils;if(J.nativeSupport=void 0!==F.placeholder,!J.nativeSupport){for(p=document.getElementsByTagName("input"),h=document.getElementsByTagName("textarea"),b="false"===H.getAttribute(j),f="false"!==H.getAttribute(q),A=document.createElement("style"),A.type="text/css",y=document.createTextNode("."+k+" { color:"+B+"; }"),A.styleSheet?A.styleSheet.cssText=y.nodeValue:A.appendChild(y),G.insertBefore(A,G.firstChild),S=0,N=p.length+h.length;N>S;S++)T=p.length>S?p[S]:h[S-p.length],E=T.attributes.placeholder,E&&(E=E.nodeValue,E&&K.inArray(w,T.type)&&v(T));x=setInterval(function(){for(S=0,N=p.length+h.length;N>S;S++)T=p.length>S?p[S]:h[S-p.length],E=T.attributes.placeholder,E&&(E=E.nodeValue,E&&K.inArray(w,T.type)&&(T.getAttribute(U)||v(T),(E!==T.getAttribute(V)||"password"===T.type&&!T.getAttribute(I))&&("password"===T.type&&!T.getAttribute(I)&&K.changeType(T,"text")&&T.setAttribute(I,"password"),T.value===T.getAttribute(V)&&(T.value=E),T.setAttribute(V,E))));f||clearInterval(x)},100)}J.disable=J.nativeSupport?e:u,J.enable=J.nativeSupport?e:i}(this);

    /*
* debouncedresize: special jQuery event that happens once after a window resize
*
* latest version and complete README available on Github:
* https://github.com/louisremi/jquery-smartresize/blob/master/jquery.debouncedresize.js
*
* Copyright 2011 @louis_remi
* Licensed under the MIT license.
*/
    (function($) {
      var $event = $.event,
          $special,
          resizeTimeout;

      $special = $event.special.debouncedresize = {
        setup: function() {
          $( this ).on( "resize", $special.handler );
        },
        teardown: function() {
          $( this ).off( "resize", $special.handler );
        },
        handler: function( event, execAsap ) {
          // Save the context
          var context = this,
              args = arguments,
              dispatch = function() {
                // set correct event type
                event.type = "debouncedresize";
                $event.dispatch.apply( context, args );
              };

          if ( resizeTimeout ) {
            clearTimeout( resizeTimeout );
          }

          execAsap ?
            dispatch() :
          resizeTimeout = setTimeout( dispatch, $special.threshold );
        },
        threshold: 200
      };
    })(jQuery);

    $(function($){
      //Return elements that have an ancestor/parent matching the supplied selector
      $.fn.hasAncestor = function(a) {
        return this.filter(function() {
          return $(this).closest(a).length > 0;
        });
      };

      //Side up and remove
      $.fn.slideUpAndRemove = function(speed){
        if(typeof speed == 'undefined') speed = 200;
        $(this).each(function(){
          $(this).slideUp(speed, function(){
            $(this).remove();
          });
        });
      }

      //Fade out image, replace src, fade back in when loaded
      $.fn.fadeToAnotherImage = function(newSrc, callback){
        var $img = $(this);
        if($img.attr('src') != newSrc) {
          $img.animate({opacity:0}, 200, function(){
            var oldHeight = $img.height();
            $img = $img.replaceImageWithOneOfNewSrc(newSrc);
            $img.css({ height: oldHeight, display: 'block' }); //Placeholder height until loaded. d:b required for occupying space in FF
            $img.imagesLoaded(function(){
              $img.css({height: '', display: ''}); //Revert to natural height
              $img.animate({opacity:1}, 200);
              if(callback) callback($img);
            });
          });
        }
        return $img;
      }

      $.fn.replaceImageWithOneOfNewSrc = function(newSrc) {
        //Used in a few places to avoid blank.gif breaking imagesLoaded
        var newTag = $(this).clone().wrap('<div />').parent().html();
        newTag = newTag.replace(/(src=")([^"]*)/gi, "$1" + newSrc);
        var $newTag = $(newTag);
        $(this).after($newTag).remove();
        return $newTag;
      }

      /// Reusable function to expand/contract a div
      $(document).on('click', 'a[data-toggle-target]', function(e){
        var $target = $($(this).data('toggle-target'));
        if($target.hasClass('height-hidden')) {
          $target.hide().removeClass('height-hidden');
        }
        $(this).find('.state').html( $target.is(':visible') ? '+' : '-' );
        $target.slideToggle(200);
        e.preventDefault();
      });

      //Already visible? Set state
      $('a[data-toggle-target]').each(function(){
        var $target = $($(this).data('toggle-target'));
        $(this).find('.state').html( ($target.is(':visible') && !$target.hasClass('height-hidden')) ? '-' : '+' );
      });

      //Redirect dropdowns
      $(document).on('change', 'select.navdrop', function(){
        window.location = $(this).val();
      });

      //General purpose lightbox
      $('a[rel="fancybox"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="robb_report"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="chand"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="golf"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="itc"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="star"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="juhu"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="kol"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="jai"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="cnbc"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="london"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="ahmd"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="BHGCC"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="IIM"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="vito"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="marriott"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="bang"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      
      $('a[rel="a-club"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="pune-store"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="bhopal-store"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="soho-house-2"]').fancybox($.extend({}, fbOpts, { titleShow: false }));

      $('a[rel="pro-am"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="chennai"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="amcham"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="matchipl"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="brit-polo"]').fancybox($.extend({}, fbOpts, { titleShow: false }));

      $('a[rel="punjabi-delhi"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="koregaon-pune"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="whiskey"]').fancybox($.extend({}, fbOpts, { titleShow: false }));

      $('a[rel="DLF"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="edinburgh"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="masters"]').fancybox($.extend({}, fbOpts, { titleShow: false }));	
      $('a[rel="royale"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="press_launch"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="ind"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="maharaja"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="cocktail"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="wine"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="banjara"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="banglore"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="gurgaon"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="banglore-store"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="delhi"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="year-celebrate"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="old-wine"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="christmas"]').fancybox($.extend({}, fbOpts, { titleShow: false }));

      $('a[rel="child"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="gk2"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="soho"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
      $('a[rel="movember"]').fancybox($.extend({}, fbOpts, { titleShow: false }));

      /// NAV
      //Show expander plusses
      $('.multi-level-nav ul li a').each(function(){
        var $siblingUL = $(this).siblings('ul');
        if($siblingUL.length > 0) {
          if($siblingUL.hasClass('listed')) {
            $(this).addClass('has-children listing-title');
          } else {
            $(this).addClass('has-children').append('<span class="exp">+</span>');
          }
        }
      });

      //Handle expanding nav
      $(document).on('click clickinstant', '.multi-level-nav a.has-children', function(e){
        var navAnimSpeed = 200;
        if(e.type == 'clickinstant') {
          navAnimSpeed = 0;
        }

        //Mobile main nav?
        if($(this).closest('#main-nav').length == 1 && $('#main-nav').css('position') == 'fixed') {
          if($(this).parent().hasClass('mobile-expanded')) {
            $(this).siblings('ul').slideUp(navAnimSpeed, function(){
              $(this).css('display','').parent().removeClass('mobile-expanded');
            });
          } else {
            $(this).siblings('ul').slideDown(navAnimSpeed, function(){
              $(this).css('display','').parent().addClass('mobile-expanded');
            });
          }
        } else {
          //Large menu
          //Not for list titles
          if($(this).hasClass('listing-title')) return true;

          //Set some useful vars
          var $tierEl = $(this).closest('[class^="tier-"]');
          var $tierCont = $tierEl.parent();
          var targetTierNum = parseInt($tierEl.attr('class').split('-')[1]) + 1;
          var targetTierClass = 'tier-' + targetTierNum;
          var $targetTierEl = $tierCont.children('.' + targetTierClass);

          ///Remove nav for all tiers higher than this one
          $tierCont.children().each(function(){
            if(parseInt($(this).attr('class').split('-')[1]) >= targetTierNum) {
              $(this).slideUpAndRemove(navAnimSpeed);
            }
          });

          //Are we expanding or collapsing
          if($(this).hasClass('expanded')) {
            //Collapsing. Reset state
            $(this).removeClass('expanded').find('.exp').html('+');
          } else {
            ///Show nav
            //Reset other nav items at this level
            $tierEl.find('a.expanded').removeClass('expanded').find('.exp').html('+');
            //If next tier div doesn't exist, make it
            if($targetTierEl.length == 0) {
              $targetTierEl = $('<div />').addClass(targetTierClass).appendTo($tierCont).hide();
            }
            $targetTierEl.empty().stop().append($(this).siblings('ul').clone().attr('style','')).slideDown(navAnimSpeed, function(){
              $(this).css('height', ''); //Clear height
            });
            //Mark as expanded
            $(this).addClass('expanded').find('.exp').html('-');
          }
        }
        return false;
      });

      
      //Sort out expanded nav. Recursively.
      var sanity = 0;
      function recursiveNavClicker() {
        var $topLI = $('#main-nav > .multi-level-nav > div:last > ul > li:has(.active)').first();
        if($topLI.length > 0) {
          var $child = $topLI.children('a');
          if(!$child.hasClass('expanded')) {
            $child.trigger('clickinstant');
            if(sanity++ < 100) recursiveNavClicker();
          }
        }
        return false;
      } 

      recursiveNavClicker();
       

      /// Mobile nav
      $(document).on('click', '.mobile-nav-toggle', function(e){
        e.preventDefault();
        $('body').toggleClass('reveal-mobile-nav');
        $('#main-nav div[class^="tier-"]:not(.tier-1)').remove(); //Remove any expanded rows
      });
      $('<a href="#" class="mobile-nav-toggle" id="mobile-nav-return"></a>').appendTo('body');


      //For all image fades
      var imageFadeInSpeed = 300;

      //Fade in images in product blocks
      $('.product-block .image-cont').each(function(){
        var $cont = $(this);
        $(this).find('img').imagesLoaded(function(){
          $cont.animate({opacity:1}, imageFadeInSpeed);
        });
      });

      //For fading in other images created by js
      function fadeInImageWhenReady($el, callback) {
        var $imgs = $el.is('img') ? $el : $el.find('img');
        $imgs.css('opacity', 0).imagesLoaded(function(){
          $imgs.animate({opacity: 1}, imageFadeInSpeed);
          if(callback) {
            callback();
          }
        });
      };

      //Enables any images inside a container
      function awakenImagesFromSlumber($cont) {
        $cont.find('img[data-src]').each(function(){
          $(this).replaceImageWithOneOfNewSrc($(this).data('src'));
        });
      };

      /// View modes for collection page
      function saveGridStreamChoice(type) {
        var cfg = { expires:1, path:'/', domain:window.location.hostname };
        $.cookie('gridstream', type, cfg);
      }
      function getGridStreamChoice() {
        return $.cookie('gridstream');
      }

      $(document).on('click', '#view-as-tiles', function(){
        if(!$(this).hasClass('active')) {
          $(this).addClass('active');
          $('#view-as-stream').removeClass('active');
          saveGridStreamChoice('grid');
          var $listing = $('.collection-listing-stream').removeClass('collection-listing-stream').addClass('collection-listing');
        }
        return false;
      });

      $(document).on('click', '#view-as-stream', function(){
        if(!$(this).hasClass('active')) {
          $(this).addClass('active');
          $('#view-as-tiles').removeClass('active');
          saveGridStreamChoice('stream');
          var $listing = $('.collection-listing').removeClass('collection-listing').addClass('collection-listing-stream');
          //All images enabled in this view (do before optionate, in case it switches images)
          awakenImagesFromSlumber($listing);
          //Close any open doodads & reset 'style=' styling to default
          $listing.find('.product-block').stop().each(function(){
            if($(this).hasClass('expanded')) {
              $(this).removeClass('expanded');
            }
            $(this).add($(this).find('.product-detail').stop()).removeAttr('style', '');
            $(this).find('select[name="id"]').trigger('optionate');
          });
        }
        return false;
      });
      //Have we chosen before?
      if($('#view-as-stream, #view-as-tiles').length > 0 && getGridStreamChoice() != null) {
        if(getGridStreamChoice() == 'stream') {
          $('#view-as-stream').trigger('click');
        } else {
          $('#view-as-tiles').trigger('click');
        }
      }

      

      //For each product block in a listing
      $('.collection-listing .product-block, .collection-listing-stream .product-block').each(function(){
        //Add close button
        $('<a href="#" class="close-detail">X</a>').data('block', $(this)).appendTo($(this).find('.product-detail'));
      });


      /// Collection slider
      jQuery.fn.reverse = [].reverse; //Genius deserves credit: http://stackoverflow.com/questions/1394020/jquery-each-backwards

      //Evaluate visibility of left/right buttons, and height
      $(window).on('debouncedresize checkcollectionpaging', function(){
        $('.collection-slider:has(.product-block)').each(function(){
          var $prods = $(this).find('.product-block > .block-inner');
          $(this).toggleClass('no-pages', $prods.first().offset().top == $prods.last().offset().top);
          var tallest = 0;
          $prods.each(function(){
            var h = $(this).outerHeight();
            if(h > tallest) tallest = h;
          });
          var $firstBlock = $prods.first().parent();
          var vertPad = parseInt($firstBlock.css('padding-top')) + parseInt($firstBlock.css('padding-bottom'));
          $(this).find('.collection-listing').css('height', tallest + vertPad);
          $(this).find('.product-block').css('height', tallest);
        });
      });

      //Init slider
      $('.collection-slider').each(function(){
        var $nextPrevCont = $(this).find('.view-all, .has-paging'); //One or the other
        $(this).imagesLoaded(function(){
          $('<a class="prev" href="#">&larr;</a>').prependTo($nextPrevCont);
          $('<a class="next" href="#">&rarr;</a>').appendTo($nextPrevCont);
          $(window).trigger('checkcollectionpaging');
        });
      });
      $('.collection-slider').on('click', '.prev, .next', function(){
        //Find items visible in first row
        var showingNext = $(this).hasClass('next');
        var $items = $(this).closest('.collection-slider').find('.product-block');
        var $cont = $items.parent();
        var itemsToMove = [];
        var runningOffset = 0;
        if(showingNext) {
          //Next
          $items.each(function(index){
            if(index == 0) {
              runningOffset = $(this).offset().top;
              itemsToMove.push($(this));
            } else {
              if($(this).offset().top == runningOffset) {
                itemsToMove.push($(this));
              } else {
                return false; //Break loop
              }
            }
          });
        } else {
          //Previous
          var contWidth = $cont.width();
          $items.reverse().each(function(){
            runningOffset += $(this).outerWidth();
            if(runningOffset <= contWidth) {
              itemsToMove.push($(this));
            } else {
              return false; //Break loop
            }
          });
        }
        //Fade out
        $items.stop().animate({opacity: 0}, 500, function(){
          //Rearrange
          $.each(itemsToMove, function(index, item){
            if(showingNext) {
              $cont.append(item);
            } else {
              $cont.prepend(item);
            }
          });
          //Fade in
          $items.stop().animate({opacity: 1}, 500);
        });
        return false;
      });

      /// Show lightbox for any shrunken images inside certain areas
      var imageKeys = ['_pico.','_icon.','_thumb.','_small.','_compact.','_medium.','_large.','_grande.'];
      $('.lightboximages img').each(function(){
        if(!$(this).parent().is('a')) {
          var imgurl = $(this).attr('src');
          for(var i = 0; i < imageKeys.length; i++) {
            if(imgurl.indexOf(imageKeys[i]) > -1) {
              imgurl = imgurl.replace(imageKeys[i], '.');
              break;
            }
          }
          var $wrapa = $('<a>').attr('href', imgurl).addClass('fancyboximg');
          $(this).wrap($wrapa);
          $(this).parent().fancybox(fbOpts);
        }
      });

      /// Galleries (inc. product page)
      $(document).on('click select', '.gallery .thumbnails a', function(e){
        var newMainImageURL = $(this).attr('href');
        var $mainImageArea = $(this).closest('.gallery').find('.main-image');
        var $mainATag = $mainImageArea.find('a');
        //If this is a change in main image...
        if($mainATag.data('href') != $(this).data('full-size-url')) {
          //Set active class
          $(this).addClass('active').siblings().removeClass('active');
          //Set main image data - so we know which one is selected
          $mainATag.data('href', $(this).data('full-size-url'));
          //Set link if on product page - for lightbox
          if($mainATag.hasClass('shows-lightbox')) {
            $mainATag.attr('href', $(this).data('full-size-url'));
          }
          $mainImageArea.find('img').fadeToAnotherImage(newMainImageURL, function($img){
            $img.closest('.inner').trigger('changedsize');
          });
        }
        e.preventDefault();
      });

      $(document).on('optionate', 'select[name="id"]', function(){
        if(typeof $(this).data('optionated') == 'undefined') {
          $(this).data('optionated', true);
          var prodId = parseInt($(this).attr('id').split('-')[2]);
          for(var i=0; i<window.productJSON.length; i++) {
            var prodJSON = window.productJSON[i];
            if(prodJSON.id == prodId) {
              new Shopify.OptionSelectors($(this).attr('id'), { product: prodJSON, onVariantSelected: window.selectCallback, enableHistoryState: $('body').hasClass('template-product') });

              
              break;
            }
          }
        }
      });

      //Default stream view - process dropdowns right away
      $('.collection-listing-stream select[name="id"]').trigger('optionate');

      /// Product page
      //Dropdowns
      $('#main-product-detail select[name="id"]').trigger('optionate');
      $('#main-product-detail').on('click', '.gallery .main-image a', function(){

        //Create list of imgs to box, so prev/next works
        var $thumbs = $(this).closest('.gallery').find('.thumbnails');
        if($thumbs.length > 0) {
          //Create dupes, rejig, launch matching link
          var $boxObjs = $thumbs.clone();
          $('body > .t-lightbox-thumbs').remove(); //Tidy
          $boxObjs.addClass('t-lightbox-thumbs').hide().appendTo('body').find('a').each(function(){
            $(this).attr('href', $(this).attr('data-full-size-url'));
          }).attr('rel', 'gallery').fancybox($.extend({}, fbOpts, { cyclic: true })).filter('[href="' + $(this).attr('href') + '"]').trigger('click');
        } else {
          //Create dupe of self and launch - thumbs may be hidden
          $(this).clone().fancybox($.extend({}, fbOpts, { cyclic: true })).trigger('click');
        }
        return false;
      });

      
      /// AJAX add to cart
      var cartPopupTemplate = [
        '<div id="cart-summary-overlay" class="cf">',
        '<div class="item">',
        '<div>'+"Just added:"+'</div>',
        '<div class="cols">',
        '<div class="img"><img src="[[image_url]]" /></div>',
        '<div class="info">',
        '<div>[[title]]</div>',
        '<div>[[price]]</div>',
        '</div>',
        '<div class="detail">',
        '<div>'+"Qty"+' [[quantity]]</div>',
        '<div>'+"Total"+' [[line_price]]</div>',
        '</div>',
        '</div>',
        '</div>',
        '<div class="cart">',
        '<div>',
        "Subtotal"+' <span>[[subtotal]]</span>',
        '</div>',
        '<div class="cart-text">'+"Incl. shipping"+'&nbsp;</div>',
        '<div>',
        '<a id="shop-more" class="button altcolour" href="#">'+"Keep Shopping"+'</a>',
        '<a class="button" href="/cart">'+"Cart"+'</a>',
        '</div>',
        '</div>',
        '</div>'
      ].join('');
      var shopifyAjaxAddURL = '/cart/add.js';
      var shopifyAjaxCartURL = '/cart.js';
      var shopifyAjaxStorePageURL = '/search';

      $(document).on('submit', 'form[action="/cart/add"]:not(.noAJAX)', function(e) {
        var $form = $(this);
        //Disable add button
        $form.find('input[type="submit"]').attr('disabled', 'disabled').each(function(){
          $(this).data('previous-value', $(this).val());
        }).val("Adding...");

        //Hide any existing notifications
        $('#cart-summary-overlay #shop-more').triggerHandler('click');

        //Add to cart
        $.post(shopifyAjaxAddURL, $form.serialize(), function(itemData) {
          //Enable add button
          $form.find('input[type="submit"]').removeAttr('disabled').each(function(){
            $btn = $(this);
            //Set to 'DONE', alter button style, wait a few secs, revert to normal
            $btn.val("Thank you!").addClass('inverted');
            window.setTimeout(function(){
              $btn.removeClass('inverted').val($btn.data('previous-value'));
            }, 3000);
          });

          //Get our data
          var addedDataJSON = $.parseJSON(itemData);

          //Get current cart state
          $.get(shopifyAjaxCartURL, function(cartData){
            var cartDataJSON = $.parseJSON(cartData);
            var addedQty = $form.find('input[name="quantity"]').length ? parseInt($form.find('input[name="quantity"]').val()) : 1;
            var addedImage = addedDataJSON.image;

            //Now we have all the data, build the shade
            var cartShadeHTML = cartPopupTemplate;
            cartShadeHTML = cartShadeHTML.replace('[[title]]', addedDataJSON.title);
            cartShadeHTML = cartShadeHTML.replace('[[quantity]]', addedQty);
            cartShadeHTML = cartShadeHTML.replace('[[image_url]]', addedImage);
            cartShadeHTML = cartShadeHTML.replace('[[price]]', Shopify.formatMoney(addedDataJSON.price));
            cartShadeHTML = cartShadeHTML.replace('[[line_price]]', Shopify.formatMoney(addedDataJSON.price * addedQty));
            cartShadeHTML = cartShadeHTML.replace('[[subtotal]]', Shopify.formatMoney(cartDataJSON.total_price));

            var $cartShade = $(cartShadeHTML);
            $cartShade.find('#shop-more').bind('click', function(){
              $cartShade.animate({top: - $cartShade.outerHeight()}, 500, function(){ $(this).remove(); });
              return false;
            });
            $cartShade.prependTo('body').css('top', - $cartShade.outerHeight()).animate({top: 0}, 500);

            
          }, 'html');

          //Update header summaries
          $.get(shopifyAjaxStorePageURL, function(data){
            var cartSummarySelector = '#pageheader .cart-summary .cart-count';
            var $newCartObj = $('<div>' + data + '</div>').find(cartSummarySelector);
            var $currCart = $(cartSummarySelector);
            $currCart.html($newCartObj.html());
          });
        }, 'text').error(function(data) {
          //Enable add button
          $form.find('input[type="submit"]').removeAttr('disabled').each(function(){
            $(this).val($(this).data('previous-value'));
          });

          //Not added, show message
          if(typeof(data) != 'undefined' && typeof(data.status) != 'undefined') {
            var jsonRes = $.parseJSON(data.responseText);
            window.showQuickPopup(jsonRes.description, $form.find('input[type="submit"]:first'));
          } else {
            //Some unknown error? Disable ajax and add the old-fashioned way.
            $form.addClass('noAJAX');
            $form.submit();
          }
        });
        return false;
      });
      $(window).scroll(function(){
        //Hide notifications on scroll
        $('#cart-summary-overlay #shop-more').triggerHandler('click');
      });
      

      //Show a quick generic text popup above an element
      window.showQuickPopup = function(message, $origin){
        var $popup = $('<div>').addClass('simple-popup');
        var offs = $origin.offset();
        $popup.html(message).css({ 'left':offs.left, 'top':offs.top }).hide();
        $('body').append($popup);
        $popup.css('margin-top', - $popup.outerHeight() - 10);
        $popup.fadeIn(200).delay(3500).fadeOut(400, function(){
          $(this).remove();
        });
      };

      //Start any slideshows on the page
      $('.flexslider').each(function(){
        $(this).flexslider({
          animation: 'slide',
          slideshow: $(this).hasClass('auto-play'),
          prevText: '&lsaquo;',
          nextText: '&rsaquo;',
          controlNav: false,
          directionNav: $(this).find('img').length > 1,
          slideshowSpeed: 4000 // Milliseconds to wait between slides
        });
      });

      //Quantity inputs - select when focus
      $(document).on('focusin click', 'input.select-on-focus', function(){
        $(this).select();
      }).on('mouseup', 'input.select-on-focus', function(e){
        e.preventDefault(); //Prevent mouseup killing select()
      });

      //Using JS in our forms?
      $('body').addClass('jsforms');
      $('#template, #template-contact').on('focusout keyup paste', 'input, textarea', function(){
        $('label[for="' + $(this).attr('id') + '"]').toggle($(this).val().length == 0);
      }).on('click', 'label', function(e){
        $('[id="' + $(this).attr('for') + '"]').focus();
      });

      //Shopify forms don't all have correct label attributes
      $('#template label, #template-contact label').each(function(){
        var $sibinputs = $(this).siblings('input:not([type="submit"]), textarea');
        if($sibinputs.length == 1 && $sibinputs.attr('id').length > 0) {
          $(this).attr('for', $sibinputs.attr('id'));
        }
      });

      $(window).load(function(){
        //Show/hide labels
        $('#template input').trigger('keyup');
        $('#template-contact input').trigger('keyup');
      });

      /// Main search input
      $('#pageheader .search-box input[type="text"]').bind('focusin focusout', function(e){
        $(this).closest('.search-box').toggleClass('focus', e.type == 'focusin');
      });


      /// Live search
      var preLoadLoadGif = $('<img src="//www.truefittandhill.in/cdn/shop/t/69/assets/ajax-load.gif?v=62939699503414190391692862530" />');
                             var searchTimeoutThrottle = 500;
                             var searchTimeoutID = -1;
                             var currReqObj = null;
                             var $resultsBox = $('<div class="results-box" />').appendTo('#pageheader .search-box');
      $('#pageheader .search-box input[type="text"]').bind('keyup change', function(){
        //Only search if search string longer than 2, and it has changed
        if($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) {
          //Reset previous value
          $(this).data('oldval', $(this).val());

          // Kill outstanding ajax request
          if(currReqObj != null) currReqObj.abort();

          // Kill previous search
          clearTimeout(searchTimeoutID);

          var $form = $(this).closest('form');

          //Search term
          var term = '*' + $form.find('input[name="q"]').val() + '*';

          //URL for full search page
          var linkURL = $form.attr('action') + '?type=product&q=' + term;

          //Show loading
          $resultsBox.html('<div class="load"></div>');

          // Do next search (in X milliseconds)
          searchTimeoutID = setTimeout(function(){
            //Ajax hit on search page
            currReqObj = $.ajax({
              url: $form.attr('action'),
              data: {
                type: 'product',
                view: 'json',
                q: term,
              },
              dataType: "json",
              success: function(data){
                currReqObj = null;
                if(data.results_total == 0) {
                  //No results
                  $resultsBox.html('<div class="note">'+ "No results found" +'</div>');
                } else {
                  //Numerous results
                  $resultsBox.empty();
                  $.each(data.results, function(index, item){
                    var $row = $('<a></a>').attr('href', item.url);
                    $row.append('<div class="img"><img src="' + item.thumb + '" /></div>');
                    $row.append(item.title);
                    $resultsBox.append($row);
                  });
                  $resultsBox.append('<a href="' + linkURL + '" class="note">See all results (' + data.results_total + ')</a>');
                                     }
                                     }
                                     });
                }, searchTimeoutThrottle);
              } else if ($(this).val().length <= 2) {
              //Deleted text? Clear results
              $resultsBox.empty();
            }
                                }).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function(){
              //Focus, show results
              $resultsBox.fadeIn(200);
            }).bind('click', function(e){
              //Click, prevent body from receiving click event
              e.stopPropagation();
            });
            $('body').bind('click', function(){
              //Click anywhere on page, hide results
              $resultsBox.fadeOut(200);
            });

            //Search box should mimic live search string: products only, partial match
            $('.search-form, #search-form').on('submit', function(e){
              e.preventDefault();
              var term = '*' + $(this).find('input[name="q"]').val() + '*';
              var linkURL = $(this).attr('action') + '?type=product&q=' + term;
              window.location = linkURL;
            });

            /// Collection page
            //If a tag is active in a group, other tags within that group must be links to that tag only, within that group.
            $('.multi-tag-row .tags').each(function(){
              var $active = $(this).find('li.active');
              $(this).find('li:not(.active) a').each(function(){
                var href = $(this).attr('href');
                $active.each(function(){
                  var tag = $(this).data('tag');
                  href = href.replace('+'+tag, '').replace(tag+'+', ''); //Collection
                  href = href.replace('%2B'+tag, '').replace(tag+'%2B', ''); //Vendor
                });
                $(this).attr('href', href);
              });
            });

            /// Text that scales down - scale it up/down based on column width
            function resizeScalingTextFromColumn() {
              $('.scaled-text').each(function(){
                var $base = $(this).closest('.scaled-text-base');
                var scale = $base.width() / 1400;
                $(this).css('font-size', (scale * 100) + '%');
              });
            }
            resizeScalingTextFromColumn();
            $(window).on('debouncedresize', resizeScalingTextFromColumn);

            /// Showing dropdown signup
            $('#pageheader .util-area .signup-reveal').bind('click', function(){
              $(this).parent().toggleClass('show-drop');
              return false;
            });

            /// Collection sorting. Code courtesy of the reliably-brilliant Caroline: https://gist.github.com/carolineschnapp/11352987
            var $sortBy = $('#sort-by');
            if($sortBy.length > 0) {
              Shopify.queryParams = {};
              if (location.search.length) {
                for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                  aKeyValue = aCouples[i].split('=');
                  if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                  }
                }
              }
              $sortBy.val($sortBy.data('initval')).bind('change', function() {
                Shopify.queryParams.sort_by = $(this).val();
                location.search = $.param(Shopify.queryParams);
              });
            }
          });

          


          /****** Equal heights ********/

          $(window).on('load', function () {
            $.fn.equalHeights = function() {
              var maxHeight = 0,
                  $this = $(this);
              $this.each( function() {
                var height = $(this).innerHeight();
                if ( height > maxHeight ) { maxHeight = height; }
              });
              return $this.css('height', maxHeight);
            };
            // auto-initialize plugin
            $('[data-equal]').each(function(){
              var $this = $(this),
                  target = $this.data('equal');
              $this.find(target).equalHeights();
            });

            $('.product-block .form .input-row:nth-child(1)').equalHeights();
            $('.product-block .innerer .title').equalHeights();
            $(window).resize(function() {
              $('.product-block .form .input-row:nth-child(1)').height('auto');
              $('.product-block .form .input-row:nth-child(1)').equalHeights();
              $('.product-block .innerer .title').height('auto');
              $('.product-block .innerer .title').equalHeights();
            }); 
          });


$(window).on('load', function () {
    $('input[name="duration"]').on('change',function(){
    var _selectedVarient = $('input[name="duration"]:checked').val();
    $('.single-option-selector').val(_selectedVarient);
    $('.single-option-selector').change();
});
          
$('input[name="membership"]').on('change',function(){
    var _selectedVarient = $('input[name="membership"]:checked').val();
    $('.single-option-selector').val(_selectedVarient);
    $('.single-option-selector').change();
});
  
  $('input[name="choose-your-fragrance"]').on('change',function(){
    var _selectedVarient = $('input[name="choose-your-fragrance"]:checked').val();
    $('.single-option-selector').val(_selectedVarient);
    $('.single-option-selector').change();
});
     
$('input[name="service-card-value"]').on('change',function(){
    var _selectedVarient = $('input[name="service-card-value"]:checked').val();
    $('.single-option-selector').val(_selectedVarient);
    $('.single-option-selector').change();
});
          
          
           $('input[name="color"]').on('change',function(){
    var _selectedVarient = $('input[name="color"]:checked').val();
    $('.single-option-selector').val(_selectedVarient);
    $('.single-option-selector').change();
             
   $('.radholder input[type="radio"]').on('change',function(){$('.inline-option select option').filter(function() { 
    return ($(this).text() == $('.radholder input[type="radio"]:checked').val()); //To select Blue
}).prop('selected', true);});
             
             
})
        
         $('.radholder input[type="radio"]').on('change',function(){$('.inline-option select option').filter(function() { 
    return ($(this).text() == $('.radholder input[type="radio"]:checked').val());console.log('updated') //To select Blue
         }).prop('selected', true);});
          
  
  function setWithExpiry(key, value, ttl) {
	const now = new Date()

	// `item` is an object which contains the original value
	// as well as the time when it's supposed to expire
	const item = {
		value: value,
		expiry: now.getTime() + ttl,
	}
	localStorage.setItem(key, JSON.stringify(item))
}
  
  function getWithExpiry(key) {
	const itemStr = localStorage.getItem(key)
	// if the item doesn't exist, return null
	if (!itemStr) {
		return null
	}
	const item = JSON.parse(itemStr)
	const now = new Date()
	// compare the expiry time of the item with the current time
	if (now.getTime() > item.expiry) {
		// If the item is expired, delete the item from storage
		// and return null
		localStorage.removeItem(key)
		return null
	}
	return item.value
}
  
  
    window.modalday = $('#NewsletterPopup-ex1').data('delay-days') * 24 * 60 * 60 * 1000;
    window.modalseconds = $('#NewsletterPopup-ex1').data('delay-seconds')*1000;
  // console.log(getWithExpiry('closedmodal'));
  	setTimeout( function(){ 
      if(localStorage.getItem('modalsubscribed') == null){
        if(getWithExpiry('closedmodal') == null){
        $('#NewsletterPopup-ex1').modal();
      }
      }
//       $('#NewsletterPopup-ex1').modal();

      
  }  , modalseconds );
  
  
  $("#newslettermodalform").on("submit", function(){
   console.log('submitted');
    var fdata = $('#newslettermodalform').serialize();
            $.ajax({
            url : "https://cd4ab359.sibforms.com/serve/MUIEAKOJlMab5nO8wL02Ru04nydzkZfXSDxsCi9h_udf3pHRJximdBW0MKKH7qWQoO2aFyse_vK3PhBzsDcPTOj_uHi1hl8cin5X3ty5br7nb1__WKayrrwgObfwouFY44Z0Kj5BnmuSUBsbHKbB-Fn1qdZfcgmjzjHYTs4aX5M99jSIZ-pJUKLLR0YVPsKXraBGhpDAnfp0LhY-?isAjax=1",
            type : 'post',
            data : fdata,
            success : function( response ) {
				$('p.successmodal').show();
              	localStorage.setItem('modalsubscribed', 1);
              setTimeout( function(){jQuery.modal.close()},4000)
              
            },
            error : function( response ) {
                $('p.errormodal').show();
            }
        });
   return false;
 })
  
  $('#NewsletterPopup-ex1').on($.modal.CLOSE, function(event, modal) {
    if(!localStorage.getItem('modalsubscribed')){
      setWithExpiry('closedmodal','1',modalday)
    }
  });
  
function setItem(key, val){
    localStorage.setItem(key,val)
}
  
function getItem(key){
    localStorage.getItem(key)
}

var audi_url = new URL(window.location.href);

if (audi_url.searchParams.get('param_name')) {
  	var param_val = audi_url.searchParams.get('param_name')
    setItem('audi_app', param_val)
}

});

$( document ).ready(function() {
var pageURL = $(location).attr("href");
var waurl = "https://api.whatsapp.com/send/?phone=918657989228&text=";
var statictext = encodeURIComponent("Hi, I want to chat with Truefitt & Hill. I saw this link on ");
var encoded = encodeURIComponent(pageURL);
var newUrl = waurl + statictext + encoded;
 $('#demo').prop('href', newUrl);
});



$( document ).ready(function() {
  if(document.getElementById("shopify-chat-dummy")){
    document.getElementById("shopify-chat-dummy").style.display = "none";
  }
});
